import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Building2, Phone, Loader2, Edit, Save } from 'lucide-react';

export const BiginCompanyDialog = ({ companyForm, editingItem, saveCompany, saving, setCompanyForm, setShowCompanyDialog, showCompanyDialog }) => (
      <Dialog open={showCompanyDialog} onOpenChange={setShowCompanyDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Building2 className="w-5 h-5 text-purple-600" />
              {editingItem ? 'Edit Company' : 'Add New Company'}
            </DialogTitle>
            <DialogDescription>
              {editingItem ? 'Update company details in Zoho Bigin' : 'Create a new company in Zoho Bigin'}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Company Name *</Label>
              <Input 
                value={companyForm.name}
                onChange={(e) => setCompanyForm({...companyForm, name: e.target.value})}
                placeholder="Acme Healthcare"
              />
            </div>
            <div className="space-y-2">
              <Label>Website</Label>
              <Input 
                value={companyForm.website}
                onChange={(e) => setCompanyForm({...companyForm, website: e.target.value})}
                placeholder="www.example.com"
              />
            </div>
            <div className="space-y-2">
              <Label>Phone</Label>
              <Input 
                value={companyForm.phone}
                onChange={(e) => setCompanyForm({...companyForm, phone: e.target.value})}
                placeholder="+1 234 567 8900"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>City</Label>
                <Input 
                  value={companyForm.city}
                  onChange={(e) => setCompanyForm({...companyForm, city: e.target.value})}
                  placeholder="Mumbai"
                />
              </div>
              <div className="space-y-2">
                <Label>Country</Label>
                <Input 
                  value={companyForm.country}
                  onChange={(e) => setCompanyForm({...companyForm, country: e.target.value})}
                  placeholder="India"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label>Description</Label>
              <Textarea 
                value={companyForm.description}
                onChange={(e) => setCompanyForm({...companyForm, description: e.target.value})}
                placeholder="Company description..."
                rows={3}
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowCompanyDialog(false)}>Cancel</Button>
            <Button onClick={saveCompany} disabled={saving} className="bg-purple-600 hover:bg-purple-700">
              {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
              {editingItem ? 'Update' : 'Create'} in Bigin
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
);
